import update from 'immutability-helper';
import {isEmpty} from 'lodash';
import {useMemo} from 'react';

import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {
  BeltHistory,
  BeltHistoryReportData,
  getBeltHistoryReportData,
} from './BeltHistoryReport';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}

export interface BeltTrackingReportData {
  viewType: 'beltHistoryReport';
  title: string;
  beltHistoryReport: BeltHistoryReportData;
}

const getBeltTrackingReports = (): BeltTrackingReportData => ({
  viewType: 'beltHistoryReport',
  title: 'Belt History Report',
  beltHistoryReport: getBeltHistoryReportData(),
});

export const BeltHistoryReport = ({value, onUpdate}: Props) => {
  const config = useMemo(
    () =>
      !isEmpty(value)
        ? (value as BeltTrackingReportData)
        : getBeltTrackingReports(),
    [value]
  );

  return (
    <BeltHistory
      value={config.beltHistoryReport}
      onUpdate={(v) => {
        onUpdate?.(
          update(value ?? getBeltTrackingReports(), {
            beltHistoryReport: {
              $set: v ?? getBeltHistoryReportData(),
            },
          })
        );
      }}
    />
  );
};
